module.exports = __webpack_public_path__ + "static/media/login.66247f43.jpg";